import { useContext } from 'react'

import { UserContext } from '~/util/UserContext'

export function useCurrentUser() {
  const user = useContext(UserContext)
  return user
}
